
import React from "react";
import { useIntl } from "react-intl";

import { isBoolean } from "utils/helpers";
import m from "definedMessages";


export const withTranslation = (Component) => {
    const ComponentWithTranslations = (props) => {
        const { formatMessage } = useIntl();

        const formatMessageWithService = (message, params, service) => {
            if (isBoolean(service)) {
                const serviceMessage = service ? m.voice : m.sms;

                return `${formatMessage(serviceMessage)} ${formatMessage(message, params)}`;
            }
            return formatMessage(message, params);
        };

        return (
            <Component
                {...props}
                {...{
                    m,
                    formatMessage: formatMessageWithService
                }}
            />
        );
    };

    return ComponentWithTranslations;
};